import React, { CSSProperties, Fragment } from "react";
import { useTheme } from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  noPadding?: boolean;
  style?: CSSProperties;
}

const TabPanel = (props: React.PropsWithChildren<TabPanelProps>) => {
  const theme = useTheme();
  const {
    children,
    value,
    index,
    noPadding = false,
    style = {},
    ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{
        height: "100%",
        padding: noPadding
          ? "inherit"
          : `${theme.spacing(2)} ${theme.spacing(1)}`,
        ...style,
        display: value !== index ? "none" : style.display ?? "block",
      }}
    >
      {value === index && <Fragment>{children}</Fragment>}
    </div>
  );
};

export default TabPanel;
